import { useEffect, useState } from "react";
import styled from "styled-components";
import ProphetXLogo from "../../assets/prophetx-logo.svg";
import SporttradeLogo from "../../assets/sporttrade-logo.svg";
import OvertimeLogo from "../../assets/overtime-logo.svg";
import NovigLogo from "../../assets/novig-logo.svg";
import { getThemeData } from "../../theme";
import { useGetTheme } from "../../lib/contexts";

interface PartnerImageProps {
  glow: boolean;
  brighter: boolean;
  theme: string;
  bgColor: string;
}

const PartnersWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({color}) => color};
  padding: 0px 0 122px 0;
  overflow-y: hidden;
`;

const PartnerImage = styled.img<PartnerImageProps>`
  //max-width: 660px;
  //max-height: 500px;
  width: 220px;
  height: 120px;
  background: ${({bgColor}) => bgColor};
  //min-height: 300px;
  //min-width: 300px;
  object-fit: fit;
  transition: all 0.5s ease-in-out;
  border-radius: 10px;
  filter: ${({ glow }) => (glow ? 'brightness(125%)' : 'brightness(100%)')};
  //box-shadow: ${({ glow, theme }) => (glow ? (theme === 'dark' ? 'lightgrey 0 0 22px 2px' : 'black 0 0 22px 2px') : 'none')};
`;

const HeadingText = styled.h1`
  font-size: 2rem;
  font-weight: 800;
  background: ${({ color }) => color};
  width: fit-content;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
`;

const PartnerDivider = styled.div`
  height: 144px;
  width: 1px;
  background-color: ${({color}) => color};
  @media (max-width: 600px) {
    display: none;
  }
`;

const PartnerImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const PartnerImageWrapper = styled.div`
  background: ${({color}) => color};
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  padding: 22px;
  margin: 12px 12px;
`

const SubHeadingText = styled.span`
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 27px;
  background: ${(props) => props.color};
  width: fit-content;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
`;

const Partners = () => {
  const {theme} = useGetTheme();
  const [windowDimension, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });
  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimension]);
  return (
    <PartnersWrapper>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", paddingTop: "122px" }}>
        <div style={{ textAlign: "center" }}>
          <HeadingText color={getThemeData(theme).textColor}>
            {"Partners"}
          </HeadingText>
        </div>
        <div style={{ display: "flex", flexDirection: "row"}}>
          <SubHeadingText color={getThemeData(theme).textColor}>
            {"Trusted by industry leaders."}
          </SubHeadingText>
        </div>
      </div>
      <div style={{height: "22px"}}/>
      <PartnerImageContainer>
        {[
          ProphetXLogo,
          SporttradeLogo,
          OvertimeLogo,
          NovigLogo,
        ].map(logo => {
          return (
            <PartnerImageWrapper color={theme == 'dark' ? getThemeData(theme).bgBox1 : getThemeData('dark').bgGlobal}>
              <PartnerImage
                dir={"left"}
                src={logo}
                loading="lazy"
                decoding="async"
                alt="partner-image"
                brighter={true}
                glow={true}
                theme={theme}
                bgColor={"transparent"}
              />
            </PartnerImageWrapper>
          )
        })}
      </PartnerImageContainer>
    </PartnersWrapper>
  );
};

export default Partners;